import React, { createContext, useCallback, useContext, useState } from 'react';
import Spinner from "../Spiner/Spiner";
import TopLoadingBar from "../Spiner/TopLoadingBar";

const LoadingContext = createContext();

const LoadingContextProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);
  const [barCount, setBarCount] = useState(0);

  const triggerLoading = useCallback((status) => {
    setLoadingCount(prev => status ? prev + 1 : Math.max(0, prev - 1));
  }, []);

  const triggerBar = useCallback((status) => {
    setBarCount(prev => status ? prev + 1 : Math.max(0, prev - 1));
  }, []);

  const isLoading = loadingCount > 0;
  const isBarLoading = barCount > 0;

  return (
    <LoadingContext.Provider value={{ isLoading, isBarLoading, triggerLoading, triggerBar }}>
      {isLoading && <Spinner/>}
      {isBarLoading && <TopLoadingBar/>}
      {children}
    </LoadingContext.Provider>
  );
};

const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoadingContext must be used within a LoadingContextProvider');
  }
  return context;
};

export { LoadingContextProvider as MyLoadingContextProvider, useLoadingContext as useMyContextLoading };
